__turbopack_context__.v({
  "rating": "Rating-module-scss-module__dj6eLW__rating",
  "rating__star": "Rating-module-scss-module__dj6eLW__rating__star",
  "rating__star--empty": "Rating-module-scss-module__dj6eLW__rating__star--empty",
});
